import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { ConstantsService } from '../../constants/constants.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {

  user: any = {};
  formSubmitLoader = false;
  formSubmitted = false;
  showMainTab = true;
  showTabRegister = true;
  showTabVerifyOTP = false;
  showSuccessTab = false;
  otp: string[] = ['', '', '', ''];
  termsAccepted: boolean = false;
  showTermsModal: boolean = false;
  showError: boolean = false;
  showPrivacyPolicy: boolean = false;
   // For OTP resend functionality
  timeLeft: number = 120; 
  intervalId: any; 
  otpStartTime: number = 0;
  readonly OTP_DURATION = 120;
  canResend: boolean = false;
  constructor(private httpService: HttpService, private constants: ConstantsService, private toastr: ToastrService,private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    document.addEventListener('visibilitychange', () => {
    if (!document.hidden && this.otpStartTime > 0) {
      const elapsed = Math.floor((Date.now() - this.otpStartTime) / 1000);
      this.timeLeft = Math.max(0, this.OTP_DURATION - elapsed);

      if (this.timeLeft <= 0) {
        this.canResend = true;
        clearInterval(this.intervalId);
      }
      this.cdr.detectChanges();
    }
  });
   }

  registerUser(registerForm: NgForm) {
     this.formSubmitLoader = true;
    this.httpService.postRequest(this.constants.SERVER_URLS['REGISTER_USER'], { email: this.user.email }).subscribe(res => {
      this.formSubmitLoader = false;
      if (res.status == this.constants.RESPONSE_CODES['SUCCESS']) {
        this.toastr.success(res.message);
        this.gotToTabVerifyOTP();
        this.startTimer(); // Start the timer when OTP is sent
      } else {
        this.toastr.error(res.message);
      }
    }, (err) => {
      this.formSubmitLoader = false;
    });
  }

  onOtpInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;

    // Allow only digits
    if (!/^\d$/.test(value)) {
      input.value = '';
      return;
    } 
    this.otp[index] = value;
    if (index < 3 && value) {
      const nextInput = document.querySelector(`.otp-input-${index + 1}`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onOtpKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
  
    if (event.key === 'Backspace') {
      // If current input is empty, move to previous input
      if (!input.value && index > 0) {
        const prevInput = document.querySelector(`.otp-input-${index - 1}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      } else {
        // Clear current input if not already empty
        this.otp[index] = '';
      }
    }
  }

  onOtpInputMobile(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    if (!/^\d$/.test(value)) {
      input.value = '';
      return;
    }
    this.otp[index] = value;
    if (index < 3 && value) {
      const nextInput = document.querySelector(`.motp-input-${index + 1}`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }

  onOtpKeyDownMobile(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
  
    if (event.key === 'Backspace') {
      // If current input is empty, move to previous input
      if (!input.value && index > 0) {
        const prevInput = document.querySelector(`.motp-input-${index - 1}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      } else {
        // Clear current input if not already empty
        this.otp[index] = '';
      }
    }
  }

  verifyOTP(otpForm: NgForm) {
    this.formSubmitted = true;
    if (this.otp.join('').length != 4) {
      this.showError = true;
    }
    if (this.otp.join('').length === 4) {
      this.user.otp = this.otp.join('');
      if (!this.termsAccepted) {
        this.showTermsModal = true;
        return;
      }
      const userPayload = {
        email: this.user.email,
        otp: this.user.otp
      };
      this.formSubmitLoader = true;
      this.httpService.postRequest(this.constants.SERVER_URLS['VERIFY_OTP'], userPayload).subscribe(res => {
        this.formSubmitLoader = false;
        if (res.status == this.constants.RESPONSE_CODES['SUCCESS']) {
          this.toastr.success(res.message);
          this.user = {};
          otpForm.resetForm();
          this.gotToTabSuccess();
        } else {
          this.toastr.error(res.message);
        }
      }, (err) => {
        this.formSubmitLoader = false;
      });
    } else {
      this.toastr.error('Invalid OTP. Please try again.');
    }
  }

  gotToTabVerifyOTP() {
    this.showTabVerifyOTP = true;
    this.showTabRegister = false;
  }

  gotToTabSuccess() {
    this.showMainTab = false;
    this.showTabVerifyOTP = false;
    this.showTabRegister = false;
    this.showSuccessTab = true;
  }

  resendOTP() {
    throw new Error('Method not implemented.');
  }

  openPrivacyModal(){
    this.showPrivacyPolicy = true;
  }

  closeTermsModal(){
    this.termsAccepted = true;
    console.log('openPrivacyModal called', this.termsAccepted);
    this.showTermsModal = false;
  }
  closePrivacyModal(){
    this.showPrivacyPolicy = false;
  }

  // For OTP resend functionality
   resendOtp() {
  const data = {email: this.user.email};
  this.formSubmitLoader = true;
  this.httpService.postRequest(this.constants.SERVER_URLS['RESEND_USER_OTP'],data).subscribe(
    (res: any) => {
      this.formSubmitLoader = false;
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.toastr.success(res.message);
        this.startTimer();
        
      } else {
        this.toastr.error(res.message );
      }
    },
    (err) => {
      this.formSubmitLoader = false;
      this.toastr.error('Failed to resend OTP' );
    }
  );
 }

  startTimer() {
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }

  this.otpStartTime = Date.now(); 
  this.canResend = false;

  this.intervalId = setInterval(() => {
    const elapsed = Math.floor((Date.now() - this.otpStartTime) / 1000);
    this.timeLeft = Math.max(0, this.OTP_DURATION - elapsed);

    if (this.timeLeft <= 0) {
      clearInterval(this.intervalId);
      this.canResend = true;
      this.cdr.detectChanges();
    }
  }, 1000);
}
  formatTimer(): string {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}s`;
  }
}

